module.exports = __webpack_public_path__ + "img/ClothingRestrictions_BG.05f57cc5.jpg";